import { useEffect, useState } from 'react';

/**
 * Current epoch-ms, re-rendered every `intervalMs`. For ticking relative
 * timestamps ("3 minutes ago") and re-evaluating online/offline locally
 * between server polls, without re-fetching.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
